import React, { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { colors } from 'src/theme'
import { FileWithPreview } from 'src/components/shared/FileWithPreview'
import { addS } from 'src/utils/baseUtils'
import { MCDocument } from 'src/interfaces/mc'

interface Props {
  documents: MCDocument[]
  header?: any
}

const PDF_FILE_TYPE = 'pdf'

const MCStepDocumentsComponent = ({ header, documents }: Props) => {
  return documents?.length ? (
    <div css={tw`mt-3`}>
      <Typography css={tw`mb-1.5`} color={colors.SHADES_GREY_400} variant="h6">
        {addS(documents.length, 'Attached file')}
      </Typography>
      {documents.map((document) => (
        <FileWithPreview
          fullScreen={document.extension === PDF_FILE_TYPE}
          key={document.filePath}
          filePath={document.filePath}
          fileExtension={document.extension}
          header={header}
          previewContent={
            document.extension === PDF_FILE_TYPE ? (
              <object
                data={`${document.filePath}#toolbar=0`}
                type="application/pdf"
                css={tw`w-full h-full mt-[-5px] mx-[-5px]`}
              />
            ) : (
              <img src={document.filePath} css={tw`block w-full h-auto min-h-[100px]`} />
            )
          }
          className={tw`rounded-lg mb-3`}
        />
      ))}
    </div>
  ) : null
}

export const MCStepDocuments = memo(MCStepDocumentsComponent)
